import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Category {
  code: string;
  name: string;
}

export interface SubCategory {
  code: string;
  name: string;
  category: string;
  categoryCode: string;
}

interface ReferenceState {
  categoriesByCode: Record<string, Category>;
  subcategoriesByCode: Record<
    string,
    {
      name: string;
      category: string;
      categoryCode: string;
    }
  >;
}

const initialState: ReferenceState = {
  categoriesByCode: {},
  subcategoriesByCode: {}
};

const referenceSlice = createSlice({
  name: "reference",
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<Category[]>) {
      state.categoriesByCode = action.payload.reduce((acc, cat) => {
        acc[cat.code] = cat;
        return acc;
      }, {} as Record<string, Category>);
    },

    setSubcategories(state, action: PayloadAction<SubCategory[]>) {
      state.subcategoriesByCode = action.payload.reduce((acc, sub) => {
        acc[sub.code] = {
          name: sub.name,
          category: sub.category,
          categoryCode: sub.categoryCode
        };
        return acc;
      }, {} as ReferenceState["subcategoriesByCode"]);
    }
  }
});

export const { setCategories, setSubcategories } = referenceSlice.actions;
export default referenceSlice.reducer;
